import {
  AppColorPalette,
  InternBrandStylePalette_brand$data,
} from "../__generated__/InternBrandStylePalette_brand.graphql";
import { BrandColorPalette } from "../../../../../utils/getColorMapping";

export type ComponentColors = NonNullable<
  InternBrandStylePalette_brand$data["internStyle"]
>["colorPalettes"][number]["componentColors"];

const getColor = ({
  color,
  palette,
}: {
  color?: AppColorPalette | null;
  palette: BrandColorPalette;
}): string | null => {
  if (!color) return null;
  if (color === "PRIMARY") return palette.primary;
  if (color === "ACCENT_1") return palette.accent1;
  if (color === "ACCENT_2") return palette.accent2;
  if (color === "ACCENT_3") return palette.accent3;
  if (color === "BACKGROUND_1") return null;
  if (color === "BACKGROUND_2") return null;
  if (color === "BLACK") return "#000000";
  if (color === "GRAY") return "#ececec";
  if (color === "WHITE") return "#FFFFFF";
  return "";
};

export const convertBuildThemeToComponentColors = (
  buildTheme: NonNullable<
    InternBrandStylePalette_brand$data["appConfig"]
  >["buildTheme"],
  palette: BrandColorPalette
): ComponentColors => {
  return {
    button: {
      background:
        getColor({ color: buildTheme.primaryButtonBackground, palette }) ??
        "#fff",
      foreground:
        getColor({ color: buildTheme.primaryButtonForeground, palette }) ??
        "#000",
      outline:
        getColor({ color: buildTheme.secondaryButtonOutline, palette }) ??
        "#000",
    },
    shortcuts: {
      background:
        getColor({ color: buildTheme.primaryPillBackground, palette }) ??
        "#fff",
      foreground:
        getColor({ color: buildTheme.primaryPillForeground, palette }) ??
        "#000",
      outline:
        getColor({ color: buildTheme.secondaryPillOutline, palette }) ?? "#000",
      container:
        getColor({ color: buildTheme.pillContainerBackground, palette }) ??
        "#00000000",
    },
    badge: {
      background:
        getColor({ color: buildTheme.badgeBackground, palette }) ?? "#000",
      foreground:
        getColor({ color: buildTheme.badgeForeground, palette }) ?? "#fff",
    },
    navBar: {
      background:
        getColor({ color: buildTheme.navigationBackground, palette }) ?? "#fff",
      foreground:
        getColor({ color: buildTheme.navigationForeground, palette }) ?? "#000",
    },
    backgrounds: {
      background1: palette.background1,
      background2: palette.background2,
    },
    onboarding: {
      background:
        getColor({ color: buildTheme.onboardingBackground, palette }) ?? "#fff",
      foreground:
        getColor({ color: buildTheme.onboardingForeground, palette }) ?? "#000",
    },
  };
};
